export default __webpack_public_path__ + "static/media/background-01@2x.19c25437.jpg";